<div *ngIf="withCustomLabel" class="ml-2 small text-muted custom-search-label">Search</div>
<mat-form-field appearance="outline" class="search-field" [className]="withCustomLabel ? 'custom-label-enabled' : ''">
  <mat-label *ngIf="!withCustomLabel">Search</mat-label>
  <input #searchInput matInput placeholder="Search" type="search" />
</mat-form-field>
